var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useRef } from 'react';
import { GlobalModel } from '../../models';
export const useUpdateSync = (callback, value, comparator) => {
    _react_refresh_temp_1();
    const refDiff = useRef(value);
    if (GlobalModel.hasValueDiff({
        comparator,
        newValue: value,
        prevValue: refDiff.current,
    })) {
        callback();
        refDiff.current = value;
    }
};
_react_refresh_temp_1(useUpdateSync, "jaZhRHgAeGSqC16+64HJa4d02AA=");
